export const resolveUsers = (page = undefined, perpage = undefined) => {
  return [ 'usersService', usersService => {
    return usersService.findAll(page, perpage).then(list => list);
  }];
};

export const resolveUser = (param = 'targetuser') => {
  return [ '$stateParams', 'usersService', ($stateParams, usersService) => {
    return $stateParams[param] ? usersService.find($stateParams[param]) : undefined;
  }];
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/user/resolvers/users.resolver.js